import { Dialog, useMediaQuery } from '@mui/material';
import React from 'react';

import CertificateAutoView from 'commons/CertificateAutoView';
import { BREAKPOINTS } from 'configs/Constant';

import useStyles from './styles';

const CertificateDialog = ({ artwork, certificate, open, onClose, autoOpenDownload, ...props }) => {
  const isLaptop = useMediaQuery(BREAKPOINTS.laptop);
  const scaleMode = isLaptop ? 'yAxis' : 'xAxis';

  const classes = useStyles();
  const artworkActive = artwork?.active;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={isLaptop ? false : 'xs'}
      {...props}
    >
      <CertificateAutoView
        artwork={artwork}
        certificate={certificate}
        isShowButtonDownloadCertificate={artwork?.is_owner && artworkActive !== false}
        scaleMode={scaleMode}
        rootStyle={classes.contentDialog}
        autoOpenDownload={autoOpenDownload}
      />
    </Dialog>
  );
};

export default CertificateDialog;
